import { Card } from "@ebsco-ui/ebsco-ui";
import ShowMore from "@ebsco-ui/show-more";
import { faUser } from "@fortawesome/pro-solid-svg-icons/faUser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import contentTypeMapper from "../../../utils/merge/map-account-content-to-messages";
import messages from "./account-card-messages";

import "./account-card.scss";

const METADATA_DEFAULT_SHOW_COUNT = 3;

const block = "account-card";

const AccountCard = ({
  className,
  accountTypeMessageDescriptor,
  email,
  metadata
}) => {
  const mappedContentTypeMessages = contentTypeMapper(metadata);

  let mappedContentTypeElements;
  if (mappedContentTypeMessages.length) {
    mappedContentTypeElements = mappedContentTypeMessages.map(
      (contentTypeMessage, index) => (
        <span key={contentTypeMessage.id}>
          {index ? ", " : ""} <FormattedMessage {...contentTypeMessage} />
        </span>
      )
    );
  } else {
    mappedContentTypeElements = <FormattedMessage {...messages.zeroItems} />;
  }

  return (
    <div tabIndex="-1" className={block}>
      <Card
        className={cn(`${block}__card`, className)}
        border="all"
        isRounded={true}
        isRaised={true}
        isTransparent={false}
      >
        <FontAwesomeIcon className={`${block}__user-icon`} icon={faUser} />
        <div className={`${block}__user-information`}>
          <div className={`${block}__account-type`}>
            <FormattedMessage {...accountTypeMessageDescriptor} />
          </div>
          <div className={`${block}__email`}>{email}</div>
          <div className={`${block}__metadata`}>
            <ShowMore limit={METADATA_DEFAULT_SHOW_COUNT}>
              <ShowMore.Items>{mappedContentTypeElements}</ShowMore.Items>
              <ShowMore.Button
                key={`${block}__metadata-show-more`}
                className={`${block}__metadata-show-more`}
                type="button"
                styleType="link"
                expandContent={<FormattedMessage {...messages.showMore} />}
                collapseContent={<FormattedMessage {...messages.showLess} />}
              />
            </ShowMore>
          </div>
        </div>
      </Card>
    </div>
  );
};

AccountCard.propTypes = {
  className: PropTypes.string,
  accountTypeMessageDescriptor: PropTypes.object.isRequired,
  email: PropTypes.string.isRequired,
  metadata: PropTypes.object
};

export default AccountCard;
